module.exports = __webpack_public_path__ + "img/mycourse.d2404a68.jpg";